import { useMutation } from "@tanstack/react-query"
import { createInvitation } from "@/entities/invitation"
import { openInviteLink } from "../lib/share"

export function useInviteFriend(
	userId: number | undefined,
	onSuccess: () => void,
) {
	return useMutation({
		mutationFn: async ({ demean }: { demean: string }) => {
			if (typeof userId !== "number") {
				throw new Error("User id is required")
			}
			const data = await createInvitation(userId, demean)
			await openInviteLink(data.tg_ref_code, data.tg_invite_message_id)
			return data
		},
		onSuccess,
		onError: (error) => {
			console.error("Failed to create invitation:", error)
		},
	})
}
